import React, { useEffect, useState, useCallback } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function GestionOm({ idSolicitud, idOm }) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const [formData, setFormData] = useState({
    estructura: 0,
    proceso: 0,
    resultado: 0,
    asistencial: 0,
    reputacional: 0,
    clinica: 0,
    poblacional: 0,
    administrativo: 0,
    paraUsuarios: 0,
    paraTrabajadores: 0,
    legal: 0,
    financiera: 0,
    probabilidad: 0,
  });
  const [originalData, setOriginalData] = useState({});

  useEffect(() => {
    const fetchList = async () => {
      try {
        const { data } = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/QEquipoUsuario?SolicitudId=${idSolicitud}`,
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
          },
        );
        setList(data);
        setFormData(data); // Supone que los datos vienen en el mismo formato
        setOriginalData(data); // Guardamos los datos originales
      } catch (error) {
        console.error(error);
      }
    };

    fetchList();
  }, [idSolicitud]);

  const handleOpenModal = useCallback(() => setIsOpen(true), []);
  const closeModal = useCallback(() => setIsOpen(false), []);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);

  const postData = async (e) => {
    e.preventDefault();

    // Filtrar los campos modificados
    const modifiedData = Object.keys(formData).reduce((acc, key) => {
      if (formData[key] !== originalData[key]) {
        acc[key] = formData[key];
      }
      return acc;
    }, {});

    // Si no hay cambios, no hace falta enviar la solicitud
    if (Object.keys(modifiedData).length === 0) {
      alert("No se realizaron cambios.");
      return;
    }

    try {
      await axios.put(
        `https://suadesarrollo.azurewebsites.net/api/ActualizaOportunidadMejora?Id=${idOm}`,
        modifiedData,
      );
      alert("Actualizado con éxito!");
      window.location.reload("/");
      closeModal();
    } catch (error) {
      console.error(error);
      alert("Error al actualizar: " + error);
    }
  };

  const renderSelect = (name, label, options) => (
    <div className="col-sm-4">
      {label}
      <select
        name={name}
        className="btn btn-secondary btn-user btn-block"
        onChange={handleInputChange}
        value={formData[name]}
      >
        <option value="">Seleccione</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );

  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-warning"
        onClick={handleOpenModal}
      >
        Priorizar
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    OM{idOm}
                  </h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <form className="user" onSubmit={postData}>
                      <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Tipo OM
                        </h6>
                      </div>
                      <br />
                      <div className="form-group row">
                        {renderSelect("estructura", "Estructura", ["0", "1"])}
                        {renderSelect("proceso", "Proceso", ["0", "1"])}
                        {renderSelect("resultado", "Resultado", ["0", "1"])}
                      </div>
                      <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">
                          Riesgo que genera la NO intervención de la OM
                        </h6>
                      </div>
                      <br />
                      <div className="form-group row">
                        {renderSelect("asistencial", "Asistencial (Proceso)", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                        ])}
                        {renderSelect("reputacional", "Reputación", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                        ])}
                        {renderSelect("clinica", "Clinico", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                        ])}
                      </div>
                      <div className="form-group row">
                        {renderSelect("poblacional", "Poblacional", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                        ])}
                        {renderSelect("administrativo", "Administrativo", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                        ])}
                      </div>
                      <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">
                          IMPACTO
                        </h6>
                      </div>
                      <br />
                      <div className="form-group row">
                        {renderSelect("paraUsuarios", "Para Usuarios", [
                          "0",
                          "1",
                        ])}
                        {renderSelect("paraTrabajadores", "Para Trabajadores", [
                          "0",
                          "1",
                        ])}
                      </div>
                      <div className="form-group row">
                        {renderSelect("legal", "Legal", ["0", "1"])}
                        {renderSelect("financiera", "Financiera", ["0", "1"])}
                      </div>
                      <div className="card-header py-3">
                        <h6 className="m-0 font-weight-bold text-primary">
                          PROBABILIDAD
                        </h6>
                      </div>
                      <br />
                      <div className="form-group row">
                        {renderSelect("probabilidad", "Probabilidad", [
                          "1",
                          "2",
                          "3",
                          "4",
                          "5",
                        ])}
                      </div>
                      <button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                      >
                        Actualizar
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default GestionOm;
